
import { post, get, put, del, token, DEV_TOKEN } from './api.js';
import { groupBy, mapBy } from "./utils.js";

export async function count(id) {
    return get(`rsvp/?id=${id}&count=true`, token || DEV_TOKEN)
        .then(r => r.data)
        .catch(e => {
            console.log(e);
            return [];
        });
}

export async function load(id, mailbox) {

    if (mailbox === undefined) {
        mailbox = "INBOX";
    }

    return get(`rsvp/?id=${id}&mailbox=${mailbox}`, token || DEV_TOKEN)
        .then(r => r.data);
}

export async function loadRsvp(id, response_id) {
    return get(`rsvp/?id=${id}&response_id=${response_id}`, token || DEV_TOKEN)
        .then(r => r.data);
}

/**
 * Create.
 */
export function create(id, attending, attending_1, guests, comment) {

    let payload = {
        id: id,
        attending: attending,
        attending_1: attending_1,
    };

    if (guests && guests.length > 0) {
        payload.guests = guests;
    }
    if (comment) {
        payload.comment = comment;
    }

    return post('rsvp/', payload, token || DEV_TOKEN);
}

/**
 * Update.
 */
export function update(id, response_id, is_read, mailbox) {

    let payload = {
        id: id,
        response_id: response_id
    };

    if (is_read !== undefined) {
        payload.is_read = is_read;
    }

    if (mailbox !== undefined) {
        payload.mailbox = mailbox;
    }

    return put('rsvp/', payload, token || DEV_TOKEN);
}

/* 
 * Delete
 */
export function deleteRsvp(id, response_id) {
    let payload = {
        id: id,
        response_id: response_id
    };
    return del('rsvp/', payload, token || DEV_TOKEN);
}

